import { StringKeyObj } from "@novel/shared/utils/StringKeyObj";

export function parseCookiesToObj(cookiesStr?: string): StringKeyObj {
    if (!cookiesStr) {
        return {};
    }

    return cookiesStr.split(";").reduce((accum: StringKeyObj, s) => {
        const indexOfEquals = s.indexOf("=");
        accum[s.slice(0, indexOfEquals).trim()] = s.slice(indexOfEquals + 1);
        return accum;
    }, {});
}

export function getFromCookies(cookie: string, cookiesStr?: string): string | undefined {
    const cookiesObj = parseCookiesToObj(
        cookiesStr || (typeof document !== "undefined" ? document.cookie : ""),
    );
    return cookiesObj[cookie];
}
